<template>
    <v-container>
        <h1>{{ company }} - {{ payable }}</h1>
        <v-container class="bg-red">
            <v-row justify="center"><h2>Summary</h2></v-row>
        </v-container>
        <v-container>
            <v-table>
                <thead>
                    <tr>
                        <th class="text-left">Particular</th>
                        <th class="text-left">Taxable</th>
                        <th class="text-left">IGST</th>
                        <th class="text-left">CGST</th>
                        <th class="text-left">SGST</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th class="text-left">Output</th>
                        <th class="text-left">{{ output_taxable }}</th>
                        <th class="text-left">{{ output_igst }}</th>
                        <th class="text-left">{{ output_cgst }}</th>
                        <th class="text-left">{{ output_sgst }}</th>
                    </tr>
                    <tr>
                        <th class="text-left">Input</th>
                        <th class="text-left">{{ input_taxable }}</th>
                        <th class="text-left">{{ input_igst }}</th>
                        <th class="text-left">{{ input_cgst }}</th>
                        <th class="text-left">{{ input_sgst }}</th>
                    </tr>
                    <tr>
                        <th class="text-left">Credit Notes</th>
                        <th class="text-left">{{ cn_taxable }}</th>
                        <th class="text-left">{{ cn_igst }}</th>
                        <th class="text-left">{{ cn_cgst }}</th>
                        <th class="text-left">{{ cn_sgst }}</th>
                    </tr>
                    <tr>
                        <th class="text-left">Balance</th>
                        <th class="text-left"></th>
                        <th class="text-left">{{ balance_igst }}</th>
                        <th class="text-left">{{ balance_cgst }}</th>
                        <th class="text-left">{{ balance_sgst }}</th>
                    </tr>
                </tbody>
            </v-table>
        </v-container>
        <v-container class="bg-red">
            <v-row justify="center"><h2>Sale</h2></v-row>
        </v-container>
        <v-data-table
            :headers="outputheaders"
            :items="billcomputed"
            items-per-page="-1"
        ></v-data-table>

        <v-container class="bg-red">
            <v-row justify="center"><h2>Purchase</h2></v-row>
        </v-container>
        <v-data-table
            :headers="outputheaders"
            :items="input"
            items-per-page="-1"
        ></v-data-table>

        <v-container class="bg-red">
            <v-row justify="center"><h2>Credit Notes</h2></v-row>
        </v-container>
        <v-data-table
            :headers="outputheaders"
            :items="cncomputed"
            items-per-page="-1"
        ></v-data-table>
    </v-container>
    
</template>
<script setup>
import { ref, provide, computed, onMounted,onBeforeMount,watch, onUpdated, onBeforeUpdate } from 'vue'
import ShowError from '@/components/Showerror'
import { useAuthStore } from '@/stores/AuthStore'
import GSTService from '@/services/GstService'

const props = defineProps(['gmwswitch','company','date', 'billdata','purchasedata','cndata'])

var output = ref([])

var creditnote = ref([])

var outputheaders = ref([
    {
        title: 'GST No',
        align: 'start',
        sortable: true,
        key: 'gstno',
    },
    { title: 'Bill No', key: 'billno' },
    { title: 'Bill Date', key: 'billdate' },
    { title: 'Partyname', key: 'party' },
    { title: 'Taxable', key: 'taxable' },
    { title: 'IGST', key: 'igst' },
    { title: 'CGST', key: 'cgst' },
    { title: 'SGST', key: 'sgst' },
    { title: 'Bill Amount', key: 'billamount' },
])

var billdata = ref(props.billdata)
var input = ref(props.purchasedata)
var cndata = ref(props.cndata)

var company = ref(props.company)

var output_taxable = ref('')
var output_igst = ref('')
var output_cgst = ref('')
var output_sgst = ref('')

var input_taxable = ref('')
var input_igst = ref('')
var input_cgst = ref('')
var input_sgst = ref('')

var cn_taxable = ref(0)
var cn_igst = ref(0)
var cn_cgst = ref(0)
var cn_sgst = ref(0)

var balance_igst = ref(0)
var balance_cgst = ref(0)
var balance_sgst = ref(0)

var payable = ref(0)

const billcomputed = computed(() => {

    var newbilarray = billdata.value.map(v => ({
        gstno: v.party.gstno,
        billno: v.billno,
        billdate: v.billdate,
        party: v.bills_partyname,
        taxable: v.total,
        igst: v.bills_igst,
        cgst: v.bills_cgst,
        sgst: v.bills_sgst,
        billamount: v.billamount
    }))

  return newbilarray
})

const cncomputed = computed(() => {

var newbilarray = cndata.value.map(v => ({
    gstno: v.party.gstno,
    billno: v.billno,
    billdate: v.billdate,
    party: v.bills_partyname,
    taxable: v.total,
    igst: v.bills_igst,
    cgst: v.bills_cgst,
    sgst: v.bills_sgst,
    billamount: v.billamount
}))

return newbilarray
})

onBeforeMount(async () => {
    await getsummary()
})

onMounted(() => {
})

onBeforeUpdate(async () => {
  billdata.value = props.billdata
  input.value = props.purchasedata
  company.value = props.company
  cndata.value = props.cndata
  await getsummary()
})

async function getsummary(){
    var out_taxable = 0
    var out_igst = 0
    var out_cgst = 0
    var out_sgst = 0

    var in_taxable = 0
    var in_igst = 0
    var in_cgst = 0
    var in_sgst = 0

    var cnote_taxable = 0
    var cnote_igst = 0
    var cnote_cgst = 0
    var cnote_sgst = 0


    for(let i = 0; i < billcomputed.value.length; i++ ){
        out_taxable += Number(billcomputed.value[i].taxable)
        out_igst += Number(billcomputed.value[i].igst)
        out_cgst += Number(billcomputed.value[i].cgst)
        out_sgst += Number(billcomputed.value[i].sgst)
    }

    output_taxable.value = Math.round(out_taxable * 100) / 100
    output_igst.value =  Math.round(out_igst * 100) / 100
    output_cgst.value =  Math.round(out_cgst * 100) / 100
    output_sgst.value =  Math.round(out_sgst * 100) / 100

    for(let j = 0; j < input.value.length; j++ ){
        in_taxable += Number(input.value[j].taxable)
        in_igst += Number(input.value[j].igst)
        in_cgst += Number(input.value[j].cgst)
        in_sgst += Number(input.value[j].sgst)
    }

    input_taxable.value = Math.round(in_taxable * 100) / 100
    input_igst.value =  Math.round(in_igst * 100) / 100
    input_cgst.value =  Math.round(in_cgst * 100) / 100
    input_sgst.value =  Math.round(in_sgst * 100) / 100

    for(let k = 0; k < cncomputed.value.length; k++ ){
        cnote_taxable += Number(cncomputed.value[k].taxable)
        cnote_igst += Number(cncomputed.value[k].igst)
        cnote_cgst += Number(cncomputed.value[k].cgst)
        cnote_sgst += Number(cncomputed.value[k].sgst)
    }

    cn_taxable.value = Math.round(cnote_taxable * 100) / 100
    cn_igst.value =  Math.round(cnote_igst * 100) / 100
    cn_cgst.value =  Math.round(cnote_cgst * 100) / 100
    cn_sgst.value =  Math.round(cnote_sgst * 100) / 100

    balance_igst.value = Math.round((out_igst - in_igst - cnote_igst) * 100) / 100
    balance_cgst.value = Math.round((out_cgst - in_cgst - cnote_cgst) * 100) / 100
    balance_sgst.value = Math.round((out_sgst - in_sgst - cnote_sgst) * 100) / 100

    payable.value = Math.round(balance_igst.value + balance_cgst.value + balance_sgst.value)
    
}

</script>